import Grid from '../../../Common/Grid/index';
import getNoDataCellComponent from '../../../Common/NoDataCellComponent/index';
import React from 'react';
import ItemIcon from '@material-ui/icons/Favorite';
import DoneIcon from '@material-ui/icons/Done';
import PendingIcon from '@material-ui/icons/Clear';
import Tooltip from '@material-ui/core/Tooltip';
import _ from 'lodash';
import moment from 'moment';

import Icon from '../../../Common/Icon/index';
import Identifier from '../../../Common/Identifier/index';
import { toArray } from '../../../../utils/helper';

const styles = {
  type: {
    display: 'flex',
    alignItems: 'center',
  }
}

const getColumns = (profile = {}) => {
  // console.log('profff', profile);
  return _.flatten([
    { name: 'type', title: 'Item' },
    { name: 'identifiers', title: 'Identifiers' },
    (profile.stages || []).map((stage) => ({ name: `stage-${stage.id}`, title: stage.name })),
    { name: 'action', title: ' ' },
  ]);
}

const getColumnExtensions = (profile = {}) => _.flatten([
  { columnName: 'type', width: 200 },
  // { columnName: 'identifiers', width: 100 },
  // { columnName: 'lastStage', width: 150 },
  (profile.stages || []).map((stage) => ({ columnName: `stage-${stage.id}`, width: 100 })),
  { columnName: 'action', width: 100 },
]);

// const isAcknowledged = (row, stageId) => {
// return (row.stages[stageId] )
// }

const getCellComponent = (onEdit, onRemove) => ({ row, column, value }) => {
  const colName = column.name.indexOf('stage-') >= 0 ? 'stage' : column.name;
  switch (colName) {
    case 'type':
      return value ? <div style={styles.type}><Icon name={value.icon} size={50}/><span>{value.name}</span></div> : '';
    case 'identifiers':
      return toArray(value || {}).map((identifier) => (<Identifier key={identifier.id} identifier={identifier}/>));
    // case 'stage':
    //   return (row.stages)
    case 'stage':
      const stageId = column.name.substr(6);
      return row.stages && row.stages[stageId] ? <Tooltip title={`Seen at ${moment(row.stages[stageId].at).format('lll')}`}><DoneIcon style={{ color: 'green' }}/></Tooltip> : <PendingIcon style={{ color: 'red' }}/>;
    case 'action':
      return null;
    default:
      return value;
  }

};

const getLatestAcknowledgement = (acks = []) => acks.reduce((res, ack) => {
  if (!res || moment(res.at).isBefore(moment(ack.at))) {
    return ack;
  }

  return res;
}, null);

const groupByItem = (task) => {
  const items = _.keyBy(task.items, (item) => item.id);

  console.log('i1', items);

  (task.stages || []).forEach(stage => {
    _.forEach(stage.items || {}, (item, itemId) => {
      if (items[itemId]) {
        const ack = getLatestAcknowledgement(item.acknowledgements);
        if (ack && ack.acknowledged) {
          items[itemId].stages = _.assign({}, items[itemId].stages, { [stage.id]: { at: ack.at } });
        }
      }
    })
  });

  console.log('items', items);
  return _.values(items);
}

const ItemsGrid = ({ job, task, fetch, onEdit, onRemove }) => {

  const data = groupByItem(task);

  console.log('task', task);
  return <Grid
    columns={getColumns(job.profile)}
    columnExtensions={getColumnExtensions(job.profile)}
    cellComponent={getCellComponent(onEdit, onRemove)}
    fetch={_.noop}
    data={{ data }}
    noDataCellComponent={getNoDataCellComponent(<ItemIcon style={styles.noData}/>, 'items')}
  />;
};

export default ItemsGrid;



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskDialog/ItemsGrid/index.js